export default __webpack_public_path__ + "static/media/slogan.6cac3766.png";